import { useState } from 'react';

const milestones = [
  {
    year: '2012',
    title: 'بداية الرحلة',
    desc: 'انطلقت نجاحات بحلم بسيط: توفير عطور ومستحضرات تجميل أصيلة بأسعار تنافسية في السوق الخليجي.',
    icon: 'ri-seedling-line',
  },
  {
    year: '2015',
    title: 'التوسع الإقليمي',
    desc: 'وصلنا إلى أكثر من 5 دول خليجية وبنينا شبكة موردين موثوقة من أفضل الماركات العالمية.',
    icon: 'ri-global-line',
  },
  {
    year: '2018',
    title: 'منصة الجملة الرقمية',
    desc: 'أطلقنا منصتنا الإلكترونية لخدمة تجار الجملة وتسهيل عمليات الشراء والتتبع بشكل احترافي.',
    icon: 'ri-store-2-line',
  },
  {
    year: '2024',
    title: 'قيادة السوق',
    desc: 'أصبحنا الشريك التجاري الأول لأكثر من 1,200 تاجر في المنطقة مع معدل رضا يتجاوز 97%.',
    icon: 'ri-award-line',
  },
];

const visionCards = [
  {
    icon: 'ri-rocket-line',
    title: 'رؤيتنا 2030',
    desc: 'أن نكون المنصة الرائدة لتجارة العطور ومستحضرات التجميل في الوطن العربي، بحضور في 15 دولة.',
    color: 'from-[#C9A961]/15 to-[#C9A961]/5',
  },
  {
    icon: 'ri-heart-line',
    title: 'رسالتنا',
    desc: 'تمكين رواد الأعمال من النجاح في قطاع التجميل بتوفير منتجات أصيلة ودعم تجاري متكامل.',
    color: 'from-[#F5F0E8] to-white',
  },
  {
    icon: 'ri-team-line',
    title: 'قيمنا',
    desc: 'الأمانة، الجودة، والشراكة الحقيقية — مع كل تاجر نبني علاقة طويلة الأمد لا صفقة واحدة.',
    color: 'from-[#F5F0E8] to-white',
  },
];

const stats = [
  { value: '12+', label: 'عاماً من الخبرة', icon: 'ri-calendar-check-line' },
  { value: '1,200+', label: 'تاجر نشط', icon: 'ri-user-star-line' },
  { value: '5,000+', label: 'منتج أصيل', icon: 'ri-shopping-bag-3-line' },
  { value: '97%', label: 'رضا العملاء', icon: 'ri-emotion-happy-line' },
];

export default function AboutSection() {
  const [activeYear, setActiveYear] = useState(0);

  return (
    <section className="relative bg-[#FAFAF8] overflow-hidden" dir="rtl">
      <div className="h-1 w-full bg-gradient-to-r from-transparent via-[#E8721A] to-transparent" />

      {/* Decorative background text */}
      <div className="absolute top-12 left-1/2 -translate-x-1/2 text-[140px] font-black text-[#E8721A]/4 select-none pointer-events-none whitespace-nowrap hidden lg:block">
        نجاحات
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-24">

        {/* Section Header */}
        <div className="text-center mb-20 relative">
          <span className="inline-flex items-center gap-2 text-[#E8721A] text-xs font-bold tracking-widest uppercase mb-4">
            <div className="w-8 h-px bg-[#E8721A]" />
            من نحن
            <div className="w-8 h-px bg-[#E8721A]" />
          </span>
          <h2 className="text-4xl lg:text-5xl font-black text-gray-900 mb-5 leading-tight">
            قصة نجاحات
            <br />
            <span className="text-[#E8721A]">ورحلة 12 عاماً من التميز</span>
          </h2>
          <p className="text-gray-500 text-lg max-w-2xl mx-auto leading-relaxed">
            بدأنا من حلم بسيط وتحوّلنا إلى وجهة الجملة الأولى لتجار العطور
            ومستحضرات التجميل في منطقة الخليج العربي
          </p>
        </div>

        {/* Stats Row */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-20">
          {stats.map((s) => (
            <div
              key={s.label}
              className="bg-white rounded-2xl p-6 text-center group hover:-translate-y-1 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-[#E8721A]/10 rounded-xl mx-auto mb-4 group-hover:bg-[#E8721A] transition-colors duration-300">
                <i className={`${s.icon} text-2xl text-[#E8721A] group-hover:text-white transition-colors duration-300`} />
              </div>
              <div className="text-3xl lg:text-4xl font-black text-gray-900 mb-1">{s.value}</div>
              <div className="text-gray-500 text-sm font-medium">{s.label}</div>
            </div>
          ))}
        </div>

        {/* Story + Image Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-24">
          {/* Image side */}
          <div className="relative">
            <div className="rounded-3xl overflow-hidden h-[440px]">
              <img
                src="https://public.readdy.ai/ai/img_res/e1a6ff524f89d6f81d93f616381984a5.jpg"
                alt="قصة نجاحات"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900/40 via-transparent to-transparent rounded-3xl" />
            </div>

            {/* Floating quote card */}
            <div className="absolute bottom-8 right-8 left-8 bg-white/95 rounded-2xl p-5 text-right">
              <div className="flex items-start gap-3">
                <div className="text-[#E8721A] text-4xl font-black leading-none mt-1">"</div>
                <div>
                  <p className="text-gray-800 text-sm font-medium leading-relaxed mb-2">
                    نجاحات لم تكن مجرد شركة، كانت حلماً بأن يجد كل تاجر شريكاً حقيقياً يدعم مسيرته
                  </p>
                  <span className="text-[#E8721A] text-xs font-bold">— مؤسس نجاحات</span>
                </div>
              </div>
            </div>

            {/* Decorative elements */}
            <div className="absolute -top-5 -left-5 w-20 h-20 rounded-full border-2 border-[#C9A961]/20 hidden lg:block" />
            <div className="absolute -bottom-3 -right-3 w-12 h-12 rounded-full bg-[#C9A961]/10 hidden lg:block" />
          </div>

          {/* Story text */}
          <div className="text-right">
            <span className="inline-flex items-center gap-2 text-[#E8721A] text-xs font-bold tracking-widest uppercase mb-5">
              <div className="w-8 h-px bg-[#E8721A]" />
              حكايتنا
            </span>
            <h3 className="text-3xl lg:text-4xl font-black text-gray-900 mb-6 leading-tight">
              من سوق صغير إلى
              <br />
              <span className="text-[#E8721A]">منصة خليجية رائدة</span>
            </h3>
            <div className="space-y-4 text-gray-600 text-base leading-loose">
              <p>
                في عام 2012، انطلقت نجاحات من قناعة راسخة: أن تجار العطور ومستحضرات التجميل
                يستحقون شريكاً تجارياً يفهم احتياجاتهم ويدعم نموهم — لا مجرد مورّد يبيع ويختفي.
              </p>
              <p>
                بدأنا بمجموعة صغيرة من المنتجات المختارة بعناية فائقة، وبنينا علاقات ثقة مع
                الموردين العالميين الكبار لضمان الأصالة والجودة في كل منتج نقدمه.
              </p>
              <p>
                اليوم، نخدم أكثر من <strong className="text-gray-900">1,200 تاجر</strong> في منطقة
                الخليج، ونوفر مخزوناً يضم أكثر من <strong className="text-gray-900">5,000 منتج</strong> من
                أرقى الماركات العطرية والتجميلية العالمية.
              </p>
            </div>

            {/* Mini badges */}
            <div className="flex flex-wrap gap-3 mt-8">
              {['منتجات أصيلة 100%', 'شريك موثوق', 'دعم مستمر', 'أسعار تنافسية'].map((tag) => (
                <span
                  key={tag}
                  className="inline-flex items-center gap-1.5 bg-[#E8721A]/10 text-[#E8721A] text-xs font-bold px-4 py-2 rounded-full"
                >
                  <i className="ri-check-line text-sm" />
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* Timeline */}
        <div className="mb-24">
          <div className="text-center mb-12">
            <span className="inline-flex items-center gap-2 text-[#E8721A] text-xs font-bold tracking-widest uppercase mb-3">
              <div className="w-8 h-px bg-[#E8721A]" />
              محطاتنا
              <div className="w-8 h-px bg-[#E8721A]" />
            </span>
            <h3 className="text-3xl font-black text-gray-900">رحلة النمو والتطور</h3>
          </div>

          {/* Timeline tabs */}
          <div className="flex flex-wrap justify-center gap-3 mb-10">
            {milestones.map((m, i) => (
              <button
                key={m.year}
                onClick={() => setActiveYear(i)}
                className={`px-6 py-2.5 rounded-full text-sm font-bold transition-all duration-300 cursor-pointer whitespace-nowrap ${
                  activeYear === i
                    ? 'bg-[#E8721A] text-white'
                    : 'bg-white text-gray-500 hover:text-[#E8721A]'
                }`}
              >
                {m.year}
              </button>
            ))}
          </div>

          {/* Active milestone card */}
          <div className="max-w-3xl mx-auto">
            <div className="bg-white rounded-3xl p-8 lg:p-12 text-right">
              <div className="flex items-start gap-6">
                <div className="flex-1">
                  <div className="text-[#E8721A] text-5xl font-black mb-2">{milestones[activeYear].year}</div>
                  <h4 className="text-2xl font-black text-gray-900 mb-4">{milestones[activeYear].title}</h4>
                  <p className="text-gray-500 text-lg leading-relaxed">{milestones[activeYear].desc}</p>
                </div>
                <div className="w-16 h-16 flex items-center justify-center bg-[#E8721A]/10 rounded-2xl flex-shrink-0">
                  <i className={`${milestones[activeYear].icon} text-3xl text-[#E8721A]`} />
                </div>
              </div>

              {/* Progress dots */}
              <div className="flex gap-2 mt-8 justify-end">
                {milestones.map((_, i) => (
                  <button
                    key={i}
                    onClick={() => setActiveYear(i)}
                    className={`h-2 rounded-full transition-all duration-300 cursor-pointer ${
                      i === activeYear ? 'w-8 bg-[#E8721A]' : 'w-2 bg-gray-200 hover:bg-[#E8721A]/40'
                    }`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Vision Section */}
        <div>
          <div className="text-center mb-12">
            <span className="inline-flex items-center gap-2 text-[#C9A961] text-xs font-bold tracking-widest uppercase mb-3">
              <div className="w-8 h-px bg-[#C9A961]" />
              رؤيتنا المستقبلية
              <div className="w-8 h-px bg-[#C9A961]" />
            </span>
            <h3 className="text-3xl font-black text-gray-900">نحو مستقبل أكثر إشراقاً</h3>
            <p className="text-gray-500 mt-3 max-w-xl mx-auto">نبني اليوم أسس منصة عربية رائدة لتجارة العطور والتجميل تخدم رواد الأعمال في كل مكان</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {visionCards.map((card, i) => (
              <div
                key={card.title}
                className={`relative rounded-3xl p-8 bg-gradient-to-br ${card.color} text-right group hover:-translate-y-1 transition-all duration-300 overflow-hidden`}
              >
                {/* Background number */}
                <div className="absolute -bottom-4 -left-3 text-8xl font-black text-[#C9A961]/8 select-none pointer-events-none">
                  {String(i + 1).padStart(2, '0')}
                </div>

                <div className="w-14 h-14 flex items-center justify-center bg-white rounded-2xl mb-6 group-hover:bg-[#C9A961] transition-colors duration-300">
                  <i className={`${card.icon} text-2xl text-[#C9A961] group-hover:text-white transition-colors duration-300`} />
                </div>
                <h4 className="text-xl font-black text-gray-900 mb-3">{card.title}</h4>
                <p className="text-gray-600 text-sm leading-relaxed">{card.desc}</p>
              </div>
            ))}
          </div>

          {/* Future image banner */}
          <div className="mt-10 rounded-3xl overflow-hidden relative h-64 lg:h-80">
            <img
              src="https://readdy.ai/api/search-image?query=futuristic%20luxury%20Arab%20perfume%20and%20cosmetics%20market%202030%2C%20modern%20digital%20retail%20concept%2C%20glowing%20gold%20and%20white%20showroom%20with%20innovative%20technology%20displays%2C%20holographic%20product%20presentations%2C%20aspirational%20business%20growth%20vision%2C%20premium%20future%20of%20beauty%20industry&width=1200&height=400&seq=about_vision2030&orientation=landscape"
              alt="رؤية نجاحات 2030"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-l from-gray-900/80 via-gray-900/40 to-transparent" />
            <div className="absolute inset-0 flex items-center justify-end px-10 lg:px-16">
              <div className="text-right max-w-sm">
                <div className="text-[#C9A961] text-sm font-bold tracking-widest mb-3">الهدف الكبير</div>
                <h4 className="text-white text-3xl lg:text-4xl font-black mb-4 leading-tight">
                  15 دولة عربية
                  <br />
                  بحلول 2030
                </h4>
                <p className="text-white/80 text-sm leading-relaxed">
                  نسعى لأن نكون منصة العطور والتجميل الأولى على مستوى الوطن العربي
                </p>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div className="h-1 w-full bg-gradient-to-r from-transparent via-[#C9A961] to-transparent" />
    </section>
  );
}
